<div class="modal-body p-4">
    <h1>{{memberName}} locations</h1>
    <div class="memberContact">
        <div *ngFor="let location of locations" class="contactLine">
            <!-- userFocus class = if map icon is clicked -->
            <div class="contactIconWrap" [ngClass]="{userFocus: location.locationId == locationClickedId}">
                <span class="contactIcon">
                    <svg class="svg-inline--fa fa-location-dot" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-dot" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg=""><path fill="currentColor" d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"></path></svg><!-- <i class="fa-solid fa-location-dot"></i> -->
                </span>
            </div>
            <div class="contactInfo">
                <div class="fw-bold">{{memberName}} - {{location.locationName}}</div>
                {{location.locationStreet}}<br>
                {{location.locationCity}}, {{location.locationState}} {{location.locationZip}}<br>
                <a href="tel:{{location.locationPhone}}">{{location.locationPhoneDisplay}}</a><br>
                <a class="text-decoration-underline" href="javascript:void(0);" target="_blank">{{location.locationEmail}}</a>
            </div>
        </div>
    </div>
</div>